const breadCrumb = "Lançamento de Notas - Lançamento de Notas/Conceitos/Faltas";

const routes = [
  {
    path: "/lancamento-de-notas-conceitos-faltas-por-turmas",
    name: "lancamento-de-notas-conceitos-faltas-por-turmas",
    meta: {
      allowedPermissions: ["lancamento_notas_turma_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/LancamentoDeNotasConceitosFaltasPorTurma/LancamentoDeNotasConceitosFaltasPorTurmaHome.vue"
      ),
  },
  {
    path: "/lancamento-de-notas-conceitos-faltas-por-turmas/:anoMatricula/:redeEnsino/:municipioId/:escolaId/:ensinoId/:faseId/:turmaId/:areaDisciplinaId/:periodoId/editar",
    name: "lancamento-de-notas-conceitos-faltas-por-turmas-editar",
    meta: {
      allowedPermissions: [
        "alunos_avaliacao_turma_notas_create",
        "alunos_avaliacao_turma_notas",
      ],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/LancamentoDeNotasConceitosFaltasPorTurma/LancamentoDeNotasConceitosFaltasPorTurmaEditar.vue"
      ),
  },
];

export default routes;
